import { createFileRoute, redirect } from '@tanstack/react-router';
import { toast } from 'sonner';
import { z } from 'zod';

import { getMeMutation } from '@/mutations/auth/getMeMutation';

export const googleAuthSearchSchema = z.object({
  status: z.enum(['success', 'error']),
  token: z.string(),
  refreshToken: z.string(),
  // Invitation flow
  organizationId: z.string().optional(),
  invitationCode: z.string().optional(),
  redirect: z.string().optional(),
});

export const Route = createFileRoute('/_public/auth/google')({
  validateSearch: (search) => googleAuthSearchSchema.parse(search),
  beforeLoad: async ({ search, context }) => {
    const {
      status,
      token,
      refreshToken,
      organizationId,
      invitationCode,
      redirect: redirectHref,
    } = search;

    const { persistLogin, t } = context;

    const user = await getMeMutation().mutationFn({ token });

    if (status !== 'success' || !user) {
      toast.error(t('auth.loginOrSignupWith.toast.genericError'));
      throw redirect({ to: '/login' });
    }

    toast.success(t('auth.loginOrSignupWith.toast.success'));

    persistLogin(user, token, refreshToken);

    throw redirect({
      to: '/dashboard',
      search: {
        organizationId,
        invitationCode,
        redirect: redirectHref,
      },
    });
  },
});
